// AUTO-GENERATED by execution/gen_festival_facts.py — DO NOT EDIT.
// Source of truth: business/ishvaram/data/domain/astrology/festivals.yaml
// (rules 23/24/29 — engine-verified, never hand-typed). Dates are NOT
// projected here — the backend calendar API owns year dates at runtime.
// Regenerate: uv run python execution/gen_festival_facts.py

export interface FestivalFacts {
  readonly rule_type: string;
  readonly hindu_month: string;
  readonly hindu_month_hi: string;
  readonly paksha: string;
  readonly paksha_hi: string;
  readonly tithi: string;
  readonly fasting: boolean;
}

export const FESTIVAL_FACTS: Readonly<Record<string, FestivalFacts>> = {
  makar_sankranti: {
    rule_type: "sankranti",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  vasant_panchami: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Panchami",
    fasting: false,
  },
  maha_shivaratri: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturdashi",
    fasting: true,
  },
  holika_dahan: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  holi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  ugadi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    fasting: false,
  },
  chaitra_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    fasting: true,
  },
  ram_navami: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Navami",
    fasting: true,
  },
  hanuman_jayanti: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  akshaya_tritiya: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Tritiya",
    fasting: false,
  },
  buddha_purnima: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  guru_purnima: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  raksha_bandhan: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  janmashtami: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ashtami",
    fasting: true,
  },
  ganesh_chaturthi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Chaturthi",
    fasting: false,
  },
  anant_chaturdashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Chaturdashi",
    fasting: true,
  },
  pitru_paksha_start: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Pratipada",
    fasting: false,
  },
  mahalaya_amavasya: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    fasting: false,
  },
  sharad_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    fasting: true,
  },
  dussehra: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Dashami",
    fasting: false,
  },
  karwa_chauth: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  dhanteras: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: false,
  },
  narak_chaturdashi: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturdashi",
    fasting: false,
  },
  diwali: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    fasting: false,
  },
  govardhan_puja: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    fasting: false,
  },
  bhai_dooj: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Dwitiya",
    fasting: false,
  },
  chhath_puja: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Shashthi",
    fasting: true,
  },
  dev_diwali: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  mauni_amavasya: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    fasting: true,
  },
  magha_gupt_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    fasting: true,
  },
  ashadha_gupt_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    fasting: true,
  },
  pausha_putrada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  shattila_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  jaya_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  vijaya_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  amalaki_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  papmochani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  kamada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  varuthini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  mohini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  apara_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  nirjala_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  yogini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  devshayani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  kamika_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  shravana_putrada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  aja_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  parsva_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  indira_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  papankusha_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  rama_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  devuthani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  utpanna_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  mokshada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  saphala_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    fasting: true,
  },
  pradosh_vrat_jan_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_jan_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_feb_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_feb_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_mar_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_mar_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_apr_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_apr_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_may_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_may_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_jun_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_jun_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_jul_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_jul_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_aug_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_aug_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_sep_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_sep_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_oct_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_oct_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_nov_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_nov_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_dec_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  pradosh_vrat_dec_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    fasting: true,
  },
  sankashti_chaturthi_jan: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_feb: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_mar: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_apr: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_may: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_jun: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_jul: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_aug: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_sep: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_oct: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_nov: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  sankashti_chaturthi_dec: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    fasting: true,
  },
  solar_eclipse_feb_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: true,
  },
  lunar_eclipse_mar_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: true,
  },
  solar_eclipse_aug_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: true,
  },
  lunar_eclipse_sep_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  solar_eclipse_feb_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  lunar_eclipse_feb_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  solar_eclipse_aug_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: true,
  },
  lunar_eclipse_aug_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  nag_panchami: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Panchami",
    fasting: false,
  },
  hariyali_teej: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Tritiya",
    fasting: true,
  },
  onam: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  navami_shraddh: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Navami",
    fasting: false,
  },
  durgashtami: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ashtami",
    fasting: true,
  },
  makar_sankranti_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: false,
  },
  maha_navami: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Navami",
    fasting: true,
  },
  sharad_purnima: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    fasting: false,
  },
  tulsi_vivah: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    fasting: false,
  },
  vaikuntha_ekadashi: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    fasting: true,
  },
} as const;
